import { EHostType } from '../types/hostType';
import { useApplicationContext } from '../utils/applicationContext';
import { isWebView } from '../utils/isWebView';

export const useMobileBottomNavigation = () => {
  const {
    config,
    custom: { hostType },
  } = useApplicationContext();

  const isWebview = isWebView(config);

  const isMobileBottomNavigationEnabled = config.get<boolean>('mobileBottomNavigation.Enabled') ?? false;

  const isIframe = hostType === EHostType.Frame;

  return isMobileBottomNavigationEnabled && !isIframe && !isWebview;
};
